import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const Marketing = () => {
  const { darkMode } = useTheme();

  return (
    <div className={`min-h-screen p-8 ${darkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
      <div className={`max-w-4xl mx-auto ${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-lg p-12 text-center`}>
        <div className="mb-6">
          <h1 className={`text-4xl font-bold mb-4 ${darkMode ? 'text-white' : 'text-gray-900'}`}>
            Marketing
          </h1>
          <p className={`text-xl ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
            Coming Soon
          </p>
        </div>
        <div className={`mt-8 p-6 rounded-lg ${darkMode ? 'bg-gray-700' : 'bg-gray-100'}`}>
          <p className={`text-lg ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
            We're working on something exciting! Check back soon for marketing tools and features.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Marketing;

